import cn from 'classnames';
import { Typo } from 'components/ui-kit';
import { MoneyFormatter } from 'lib';
import { ChangeEvent } from 'react';
import styles from './delivery-type-card.module.scss';
import { CheckedIcon } from '../checked-icon';

type TDeliveryTypeCardProps = {
  title: string;
  price: number;
  isChecked: boolean;
  name: string;
  isDisabled?: boolean;
  onChange: (value: string) => void;
  value: string;
};

export const DeliveryTypeCard = ({
  price,
  title,
  isChecked,
  name,
  isDisabled,
  value,
  onChange,
}: TDeliveryTypeCardProps): JSX.Element => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    onChange(event.target.value);
  };

  return (
    <label className={cn({ [styles.disabledCard]: isDisabled })}>
      <input
        className={styles.input}
        type="radio"
        value={value}
        name={name}
        onChange={handleChange}
      />
      <div className={styles.deliveryTypeCard}>
        <div className={styles.content}>
          <Typo weight="600" variant="l">
            {title}
          </Typo>
          <Typo className={styles.price}>{MoneyFormatter.format(price)}</Typo>
        </div>
        <div className={styles.check}>
          {isChecked ? (
            <CheckedIcon />
          ) : (
            <div className={styles.notCheckedIcon} />
          )}
        </div>
      </div>
    </label>
  );
};
